import { render, staticRenderFns } from "./detailOld.vue?vue&type=template&id=37ef934e"
import script from "./detailOld.vue?vue&type=script&lang=js"
export * from "./detailOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports